import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * The activity types this user may schedule something of.
 *
 * The server answers both halves of the create rule — a domain manager role AND
 * reach to at least one schedulable object — so `length > 0` is the whole gate.
 * Do not gate on `insert:scheduler_schedule` (every Owner-instance `%Manager`
 * role passes that) and do not re-derive the role half on the client.
 *
 * tRPC-only — there is no GraphQL equivalent, so this is a thin `useQuery`
 * wrapper rather than a `createQueryHook` bridge.
 */
export const useGetScheduleTaskTypes = () => {
  const trpc = useTRPC();

  return useQuery(trpc.frontend.scheduler.getTaskTypes.queryOptions());
};
